import { Pipe, PipeTransform } from '@angular/core';
import { OmnisearchEntity } from '../models/omnisearch.models';

@Pipe({
  name: 'category',
  standalone: false,
})
export class CategoryPipe implements PipeTransform {
  transform(entity: OmnisearchEntity): string {
    const entityDict: Record<OmnisearchEntity, string> = {
      [OmnisearchEntity.profiles]: 'expert',
      [OmnisearchEntity.solicitationExperts]: 'solicitation expert',
      [OmnisearchEntity.opportunities]: 'opportunity',
      [OmnisearchEntity.clients]: 'client',
    };

    return entityDict[entity];
  }
}
